/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scale PCR reagent volumes for any number of reactions with overage.`)
};

const es_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escala los volúmenes de reactivos de PCR para cualquier número de reacciones con exceso.`)
};

const de_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skalieren Sie PCR-Reagenzienvolumina inklusive Überschuss auf beliebig viele Reaktionen.`)
};

const nl_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaal PCR-reagensvolumes voor elk aantal reacties met overmaat.`)
};

const fr_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptez les volumes de réactifs PCR à n'importe quel nombre de réactions avec marge de sécurité.`)
};

const it_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scala i volumi dei reagenti PCR per qualsiasi numero di reazioni con margine di sicurezza.`)
};

const pt_br2_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione os volumes de reagentes de PCR para qualquer número de reações, com excedente.`)
};

const pt_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escale os volumes de reagentes de PCR para qualquer número de reações, com excedente.`)
};

const ja_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PCR試薬の量を、オーバーヘッジを含めて任意の反応数にスケーリングします。`)
};

const zh_pcr_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据反应数量并加上损耗余量，计算 PCR 试剂用量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_tool_description", locale)
	if (locale === "en") return en_pcr_tool_description(inputs)
	if (locale === "es") return es_pcr_tool_description(inputs)
	if (locale === "de") return de_pcr_tool_description(inputs)
	if (locale === "nl") return nl_pcr_tool_description(inputs)
	if (locale === "fr") return fr_pcr_tool_description(inputs)
	if (locale === "it") return it_pcr_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_tool_description(inputs)
	if (locale === "pt") return pt_pcr_tool_description(inputs)
	if (locale === "ja") return ja_pcr_tool_description(inputs)
	return zh_pcr_tool_description(inputs)
};